import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { PrismicDocument } from '@prismicio/client';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { switchMap, tap } from 'rxjs';
import { SvgComponent } from 'icon';
import { LanguageService } from 'language';
import { CategoryService } from '../category.service';
import { SupportCategory } from '../support-types';
import { UrlifyTitlePipe } from '../urlify-title.pipe';

@Component({
  selector: 'app-articles-list',
  imports: [RouterLink, SvgComponent, UrlifyTitlePipe, NgxSkeletonLoaderModule],
  templateUrl: './articles-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArticlesListComponent {
  private categoryService = inject(CategoryService);
  public readonly category = input<PrismicDocument<SupportCategory>>();
  public readonly languageService = inject(LanguageService);
  public readonly articlesTree = toSignal(
    toObservable(this.category).pipe(
      tap(() => this.loading.set(true)),
      switchMap(category => this.categoryService.findSubCategories(category, true)),
      tap(() => this.loading.set(false))
    )
  );
  public loading = signal(false);
}
